import { SET_CUSTOMER_BOOKINGS, SET_CUSTOMER_BOOKINGS_LOADING, SET_CUSTOMER_DETAILS, SET_CUSTOMER_DETAILS_LOADING, SET_CUSTOMERS, SET_CUSTOMERS_LOADING } from "actions/customers";
import CustomerDetails from "views/ManageCustomers/CustomerDetails";


const initialState = {
  loading:false,
  list:[],
  customerDetails:null,
  customerDetailsLoading:false,
  bookingList:[],
  bookingsLoading:true,
  error:null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMERS:
      return {
        ...state,
        list: action.payload,
      };
    case SET_CUSTOMERS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_CUSTOMER_DETAILS:
      return {
        ...state,
        customerDetails: action.payload,
      };
    case SET_CUSTOMER_DETAILS_LOADING:
      return {
        ...state,
        customerDetailsLoading: action.payload,
      };
    case SET_CUSTOMER_BOOKINGS:
      return {
        ...state,
        bookingList: action.payload,
      };
    case SET_CUSTOMER_BOOKINGS_LOADING:
      return {
        ...state,
        bookingsLoading: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;